export default __webpack_public_path__ + "static/media/EAST2470.34I-34274_-18525_0.3a9a1aab.jpg";